import {
    ENABLE_SPINNER,
    DISABLE_SPINNER, 
    SET_UID,
    SET_COMPANY_NAME,
    SET_AUTH_STATE
} from '../actions/appActions';

const initialState = {
    spinner: false,
    text: '',
    uid: '',
    companyName: '',
    auth: false
};

export default function(state = initialState, action) {
    switch(action.type) {
        case ENABLE_SPINNER:
            return { ...state, spinner: true, text: action.payload };
        case DISABLE_SPINNER:
            return { ...state, spinner: false };
        case SET_UID:
            return { ...state, uid: action.payload };
        case SET_COMPANY_NAME:
            return { ...state, companyName: action.payload };
        case SET_AUTH_STATE:
            return { ...state, auth: action.payload };
        default:
            return state;
    }
}